export * from './DiscountTable'
